<script>
  import RangeInput from './rangeInput.vue'
  import CCascader from '@/components/common/questionnaire/cascade.vue'
  import STree from '@/components/common/questionnaire/fields/tree.vue'
    export default {
        name: "dynamicFieldConditionsComponent",
        props: ['fieldData'],
        components: {
          RangeInput,
          CCascader,
          STree,
        },
        data(){
          return {
            val: []
          }
        },
        created(){
          this.val = this.fieldData.value
        },
        render(h) {
            let node
            // '0',//单行文本类型 '1',//多行文本框类型 '2',//布尔类型 '3',//单选类型'4',//复选类型 '5',//整数类型
            // '6',//实数类型 '7',//百分比类型 '8',//电话类型'9',//自动编号类型 '10',//日期类型 (年月日)'11',//日期时间类型(年月日时分秒)
            //  '12',//邮箱类型 '13',//网页地址（链接）类型 '14',//省市区类型 '15',//图片类型 '16',//附件类型 '17',//关联对象 '18',//引用字段
            //     '19',//主子明细 '20',//计算类型  '21',//定位类型

            if (this.fieldData.fieldType === '0'||this.fieldData.fieldType === '1'||
                this.fieldData.fieldType === '8'||this.fieldData.fieldType === '9'||
                this.fieldData.fieldType === '12'|| this.fieldData.fieldType === '13' ||
                (this.fieldData.fieldType === '20' && this.fieldData.calcResultType === "0")||
                 this.fieldData.fieldType === '21'){
                node = h('Input', {
                    props: {
                        placeholder:"请输入"+this.fieldData.fieldName,
                        value:"",
                        // icon:"ios-search",
                        width:"auto"
                    },
                    on: {
                        'on-blur': e => {
                            this.$emit('change',{
                              ...this.fieldData,
                              value:e.target.value
                            })
                            this.fieldData.value = e.target.value
                        }
                    }
                })
            }
            if (this.fieldData.fieldType === '2'||this.fieldData.fieldType === '3') {
                let optionNodes = []
                this.fieldData.options.forEach(item => {
                    optionNodes.push(
                        h('Option', { props: { value: item.value } }, item.key)
                    )
                })
                node = h(
                    'Select',
                    {
                        props: {
                            placeholder:"请选择"+this.fieldData.fieldName,
                            value:"",
                            clearable:true,
                             },
                        on: {
                            'on-change': value => {
                              this.$emit('change',{
                                ...this.fieldData,
                                value:value
                              })
                              this.fieldData.value = value
                            }
                        }
                    },
                    optionNodes
                )
            }

            if (this.fieldData.fieldType === '4') {
                let optionNodes = []
                this.fieldData.options.forEach(item => {
                    optionNodes.push(
                        h('Option', { props: { value: item.value } }, item.key)
                    )
                })
                node = h(
                    'Select',
                    {
                        props: {
                            placeholder:"请选择"+this.fieldData.fieldName,
                            value:[],
                            multiple:true
                        },
                        on: {
                            'on-change': value => {
                                this.$emit('change',{
                                  ...this.fieldData,
                                  value:value
                                })
                                this.fieldData.value = value;
                            }
                        }
                    },
                    optionNodes
                )
            }
            if(this.fieldData.fieldType === '14'){//省市区 + 详细地址checkId
                node = h(
                  "CCascader",
                  {
                    props: {
                      placehold: "请选择"+this.fieldData.fieldName
                    },
                    on: {
                      'change': (value) => {
                        if(value && value.length){
                          if(value[0]){
                            this.$emit('change', {
                              ...this.fieldData,
                              value: value.join("/"),
                            })
                          }else{
                            this.$emit('change', {
                              ...this.fieldData,
                              value: "",
                            })
                          }
                        }
                      }
                    }
                  }
                )
              }
            if (this.fieldData.dateType == "0" && (this.fieldData.fieldType === '10') || (this.fieldData.fieldType === '20' && this.fieldData.calcResultType === "10")){
                // 日期
                node = h('DatePicker', {
                    props: {
                        fieldType: 'daterange',
                        placeholder:"请选择"+this.fieldData.fieldName,
                        value: this.val,
                        type: 'daterange',
                    },
                    on: {
                      'on-change': (value) => {
                            let dis = new Date(value[1]).getTime() - new Date(value[0]).getTime()
                            if(dis>1000*60*60*24*30){
                              this.$Message.error('日期范围不能超过30天')
                              this.$nextTick(()=>{
                                this.val = ['','']
                              })
                              return
                            }
                            this.$emit('change',{
                              ...this.fieldData,
                              value:value
                            })
                            this.fieldData.value = value;
                        }
                    }
                })
            }

            if (this.fieldData.dateType != "0" && this.fieldData.fieldType === '10' || (this.fieldData.fieldType === '20' && this.fieldData.calcResultType === "11")){
                // 日期时间
                node = h('DatePicker', {
                    props: {
                        fieldType: 'datetimerange',
                        placeholder:"请选择"+this.fieldData.fieldName,
                        format:"yyyy-MM-dd HH:mm:ss",
                        value: this.val,
                        type: "datetimerange"
                    },
                    on: {
                        'on-change': value => {
                            let dis = new Date(value[1]).getTime() - new Date(value[0]).getTime()
                            if(dis>1000*60*60*24*30){
                              this.$Message.error('日期范围不能超过30天')
                              this.$nextTick(()=>{
                                this.val = ['','']
                              })
                              return
                            }
                            this.$emit('change',{
                              ...this.fieldData,
                              value:value
                            })
                            this.fieldData.value = value
                        }
                    }
                })
            }

            if (this.fieldData.fieldType === "5" || this.fieldData.fieldType === '6' || (this.fieldData.fieldType === '20' && this.fieldData.calcResultType === "6")){
                node = h('RangeInput', {
                    props: {
                        value: this.fieldData.value,
                        title: this.fieldData.fieldName,
						placeholder:"请输入"+this.fieldData.fieldName,
                    },
                    on: {
                        'change': value => {
                          this.$emit('change',{
                            ...this.fieldData,
                            value:value
                          })
                          this.fieldData.value = value
                        }
                    }
                }) 
            }

            if(this.fieldData.fieldType === "7" || (this.fieldData.fieldType === '20' && this.fieldData.calcResultType === "7")){
              node = h('RangeInput', {
                  props: {
                      value: this.fieldData.value,
                      title: this.fieldData.fieldName,
					  placeholder:"请输入"+this.fieldData.fieldName,
                      unit: '%'
                  },
                  on: {
                      'change': value => {
                        this.$emit('change',{
                          ...this.fieldData,
                          value:value
                        })
                        this.fieldData.value = value
                      }
                  }
              }) 
            }

            //树结构
            if(this.fieldData.fieldType === "22"){
              let value = []
              if(typeof this.fieldData.value === 'string'){
                value = this.fieldData.value.split(',')
              }else if(this.fieldData.value&&this.fieldData.value.length) {
                value = [...this.fieldData.value]
              }
              node = h('STree', {
                  props: {
                      value,
                      title: "请选择" + this.fieldData.fieldName,
                      fieldData:this.fieldData,
                      cascaderOptions: this.fieldData.dicCode?JSON.parse(this.fieldData.dicCode):[],
                      changeOnSelect: true
                  },
                  on: {
                      'on-change': value => {
                        this.fieldData.value = value.join(',')//value.map(item => item.value).join(',')
                        this.$emit('change',{
                          ...this.fieldData,
                          _value:value
                        })
                        console.log(value,this.fieldData.value)
                      }
                  }
              })
            }

            return node;
        }

    }
</script>

<style scoped>

</style>
